import { Navigate, useLocation } from "react-router-dom";
import { cn } from "@fmc-digital/ui";
import { REGISTRATION_ROUTES } from "@profile/constants/routes";
import { RegistrationFeedbackSurveyBanner } from "@profile/components/molecules/RegistrationFeedbackSurveyBanner/RegistrationFeedbackSurveyBanner";
import { RegistrationFeedbackComment } from "@profile/components/organisms/RegistrationFeedbackComment/RegistrationFeedbackComment";
import {
  isValidCommentStepRating,
  toRegistrationFeedbackMetadata,
  type RegisterFeedbackLocationState,
} from "@profile/components/registration-wizard/feedback/register-feedback.navigation";
import {
  registerFeedbackContentStyles,
  registerFeedbackPageStyles,
} from "./register-feedback.styles";

export function RegisterFeedbackCommentPage() {
  const location = useLocation();
  const state = location.state as RegisterFeedbackLocationState | null;
  const registeredEmail = state?.username;
  const rating = state?.rating;
  const feedbackContext = toRegistrationFeedbackMetadata(state);

  if (!isValidCommentStepRating(rating)) {
    return <Navigate to={REGISTRATION_ROUTES.REGISTER_FEEDBACK} replace />;
  }

  return (
    <div className={cn(registerFeedbackPageStyles())} data-testid="register-feedback-comment-page">
      <div className="relative left-1/2 w-screen max-w-none -translate-x-1/2">
        <RegistrationFeedbackSurveyBanner />
      </div>
      <div className={cn(registerFeedbackContentStyles())}>
        <RegistrationFeedbackComment
          username={registeredEmail}
          rating={rating}
          feedbackContext={feedbackContext}
          feedbackState={state ?? undefined}
        />
      </div>
    </div>
  );
}
